var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { staticClass: "fixed-bar", attrs: { color: "white", flat: "" } },
        [
          !_vm.listView
            ? _c(
                "v-badge",
                {
                  attrs: {
                    color: "blue",
                    content: _vm.landedloads.length,
                    value: _vm.landedloads.length
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.landedloads.length === 0 },
                      on: {
                        click: function($event) {
                          _vm.landedLoadsSheet = true
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-window-minimize")]),
                      _vm._v("Landed")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { disabled: _vm.flights.length === 0 },
              on: {
                click: function($event) {
                  _vm.listView = !_vm.listView
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-format-list-numbered")])],
            1
          ),
          _vm._v(" "),
          !_vm.listView
            ? _c(
                "v-btn",
                {
                  attrs: { disabled: !_vm.viewingToday, color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-plus")]), _vm._v("Add ")],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.listView
        ? _c("ManifestbyInstructorView", { attrs: { flights: _vm.flights } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-bottom-sheet",
        {
          model: {
            value: _vm.landedLoadsSheet,
            callback: function($$v) {
              _vm.landedLoadsSheet = $$v
            },
            expression: "landedLoadsSheet"
          }
        },
        [
          _c(
            "v-list",
            [
              _c("v-subheader", [_vm._v("Click on a Load to view it")]),
              _vm._v(" "),
              _vm._l(_vm.landedloads, function(f) {
                return _c(
                  "v-list-item",
                  {
                    key: f.number,
                    on: {
                      click: function($event) {
                        return _vm.maximize(f.id)
                      }
                    }
                  },
                  [
                    _c(
                      "v-list-item-avatar",
                      [
                        _c(
                          "v-avatar",
                          {
                            attrs: { color: _vm.getColor(f.status), tile: "" }
                          },
                          [_c("h3", [_vm._v(_vm._s(f.number))])]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                          _c("ul", { staticClass: "load-summary" }, [
                            _c("li", [_vm._v(_vm._s(f.pilotName))]),
                            _vm._v(" "),
                            _c("li", [_vm._v(_vm._s(f.aircraft))]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v("Landed: " + _vm._s(f.land_time))
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  f.assigned_jumps
                                    ? _vm.sum(f.assigned_jumps, "instructorW") +
                                        _vm.sum(f.assigned_jumps, "customerW") +
                                        f.pilotWeight
                                    : f.pilotWeight
                                ) + " lb\n                "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "6" } },
                          [
                            _c(
                              "v-chip-group",
                              {
                                class: {
                                  landed_group: f.status === 4 || f.status < 1
                                },
                                attrs: {
                                  column: "",
                                  "active-class": "primary--text"
                                }
                              },
                              _vm._l(f.assigned_jumps, function(
                                assigned_jump,
                                j
                              ) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: assigned_jump.jumpId,
                                    attrs: { disabled: true }
                                  },
                                  [
                                    _c("span", [
                                      _c("strong", [
                                        _vm._v(_vm._s(assigned_jump.code))
                                      ]),
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(assigned_jump.fullName) +
                                          "  "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(assigned_jump.instructorName) +
                                          "\n                    "
                                      )
                                    ])
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.save($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("v-select", {
                                        ref: "plain",
                                        attrs: {
                                          items: _vm.plains,
                                          label: "Aircraft",
                                          "item-text": "name",
                                          "item-value": "id",
                                          value: _vm.editedItem.plain_id,
                                          "persistent-hint": "",
                                          outlined: "",
                                          "hide-details": "",
                                          rules: _vm.plainRules
                                        },
                                        model: {
                                          value: _vm.editedItem.plain_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "plain_id",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.plain_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("v-select", {
                                        ref: "pilot",
                                        attrs: {
                                          items: _vm.pilots,
                                          label: "Pilot",
                                          "item-text": "name",
                                          "item-value": "id",
                                          value: _vm.editedItem.pilot_id,
                                          "persistent-hint": "",
                                          outlined: "",
                                          "hide-details": "",
                                          rules: _vm.pilotRules
                                        },
                                        model: {
                                          value: _vm.editedItem.pilot_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "pilot_id",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.pilot_id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Notes" },
                                    model: {
                                      value: _vm.editedItem.notes,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "notes", $$v)
                                      },
                                      expression: "editedItem.notes"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "Submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.listView
        ? _c(
            "v-row",
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    color: "white",
                    persistent: "",
                    "max-width": "600px"
                  },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      _vm.selectInstructorBox = false
                    }
                  },
                  model: {
                    value: _vm.selectInstructorBox,
                    callback: function($$v) {
                      _vm.selectInstructorBox = $$v
                    },
                    expression: "selectInstructorBox"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.assignInstructor($event)
                            }
                          },
                          model: {
                            value: _vm.validInstructor,
                            callback: function($$v) {
                              _vm.validInstructor = $$v
                            },
                            expression: "validInstructor"
                          }
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("strong", [_vm._v(_vm._s(_vm.jump.code))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.jump.fullName) + " "),
                                _c("small", [
                                  _vm._v("(" + _vm._s(_vm.jump.customerW) + ")")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  items: _vm.filteredInstructors,
                                  "item-text": "name",
                                  "item-value": "id",
                                  placeholder: "instructors",
                                  "hide-no-data": "",
                                  rules: _vm.instructorRules
                                },
                                model: {
                                  value: _vm.jump.selectedInstructor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.jump,
                                      "selectedInstructor",
                                      $$v
                                    )
                                  },
                                  expression: "jump.selectedInstructor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1", text: "" },
                                  on: { click: _vm.closeInstBox }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "blue darken-1",
                                    type: "Submit",
                                    disabled: !_vm.validInstructor
                                  }
                                },
                                [_vm._v("Save")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "3", lg: "3" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-2 selectedJumps fixed-bar",
                      attrs: { outlined: "", tile: "" }
                    },
                    [
                      _c(
                        "v-list-item-group",
                        {
                          model: {
                            value: _vm.selectedJumps,
                            callback: function($$v) {
                              _vm.selectedJumps = $$v
                            },
                            expression: "selectedJumps"
                          }
                        },
                        [
                          _vm._l(_vm.checkedin, function(item, i) {
                            return [
                              _c(
                                "v-list-item",
                                {
                                  key: "item-" + i,
                                  attrs: {
                                    value: item.id,
                                    "active-class": "cyan lighten-3",
                                    disabled: !_vm.viewingToday
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("em", [_vm._v(_vm._s(item.code))]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(" " + _vm._s(item.fullName) + " "),
                                      _c("small", [
                                        _vm._v(
                                          "(" + _vm._s(item.customerW) + ")"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    item.instructorName !== null
                                      ? _c(
                                          "span",
                                          { staticClass: "instructorName" },
                                          [
                                            _vm._v(
                                              _vm._s(item.instructorName) + " "
                                            ),
                                            _c("small", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(item.instructorW) +
                                                  ")"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  small: "",
                                                  icon: "",
                                                  depressed: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeInstructor(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-close")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-snackbar",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function(ref) {
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._b(
                                    {
                                      attrs: { color: "orange", text: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.snackbar = false
                                        }
                                      }
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  [
                                    _vm._v(
                                      "\n                  Close\n                "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2911456322
                      ),
                      model: {
                        value: _vm.snackbar,
                        callback: function($$v) {
                          _vm.snackbar = $$v
                        },
                        expression: "snackbar"
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.snackbartext) +
                          "\n\n              "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "9", lg: "9" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-2", attrs: { outlined: "", tile: "" } },
                    [
                      _c(
                        "v-item-group",
                        {
                          model: {
                            value: _vm.activeLoad,
                            callback: function($$v) {
                              _vm.activeLoad = $$v
                            },
                            expression: "activeLoad"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            _vm._l(_vm.flights, function(flight, f) {
                              return _c(
                                "v-col",
                                {
                                  key: "flight-" + f,
                                  class: {
                                    hidden: !flight.expand,
                                    minified: "minified"
                                  },
                                  attrs: {
                                    value: flight.id,
                                    cols: "12",
                                    md: "6",
                                    sm: "6",
                                    lg: "4"
                                  }
                                },
                                [
                                  _c("v-item", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var active = ref.active
                                            var toggle = ref.toggle
                                            return [
                                              _c(
                                                "v-card",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: {
                                                    color: active
                                                      ? "cyan lighten-5"
                                                      : "",
                                                    tile: ""
                                                  },
                                                  on: { click: toggle }
                                                },
                                                [
                                                  _c(
                                                    "v-app-bar",
                                                    {
                                                      staticClass: "load-title",
                                                      attrs: {
                                                        color: _vm.getColor(
                                                          flight.status
                                                        ),
                                                        flat: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-toolbar-title", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "text"
                                                          },
                                                          [_vm._v("LOAD")]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              flight.number
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      flight.status === 4 &&
                                                      _vm.checkGate("load-undo")
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                              attrs: {
                                                                small: "",
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.unland(
                                                                    flight.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-undo-variant"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      flight.status === 4
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                              attrs: {
                                                                small: "",
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.hide(
                                                                    flight
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-window-minimize"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      flight.status <= 3 &&
                                                      flight.status > 0
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "ma-2",
                                                              attrs: {
                                                                small: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.cancel(
                                                                    flight.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    left: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-airplane-off"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Cancel\n                      "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      flight.status !== 2 &&
                                                      flight.status < 3
                                                        ? _c("StatusChip", {
                                                            attrs: {
                                                              status:
                                                                flight.status
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "load_info",
                                                          attrs: {
                                                            cols: "6",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "aircraft"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  flight.aircraft
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "pilot"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  flight.pilotName
                                                                ) + " "
                                                              ),
                                                              _c("small", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    flight.pilotWeight
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "6",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          flight.status < 3 &&
                                                          flight.status > 0 &&
                                                          flight.assigned_jumps !==
                                                            null &&
                                                          flight.assigned_jumps
                                                            .length > 0
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    disabled: !_vm.viewingToday,
                                                                    small: "",
                                                                    color:
                                                                      "green",
                                                                    "text-color":
                                                                      "white"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.depart(
                                                                        flight.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-airplane-takeoff"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " Depart\n                          "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "time",
                                                                {
                                                                  staticClass:
                                                                    "depart"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      flight.departed_time
                                                                        ? flight.departed_time
                                                                        : " --:--"
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                          _vm._v(" "),
                                                          flight.status === 3
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.sendingEmail,
                                                                    disabled: !_vm.viewingToday,
                                                                    small: "",
                                                                    color:
                                                                      "green lighten-5",
                                                                    "text-color":
                                                                      "light-green darken-4"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.land(
                                                                        flight.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-airplane-landing"
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " Land\n                          "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : flight.status ===
                                                              4
                                                            ? _c(
                                                                "time",
                                                                {
                                                                  staticClass:
                                                                    "land"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      flight.land_time
                                                                        ? flight.land_time
                                                                        : " --:--"
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.dropJump(
                                                                flight
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-chip-group",
                                                            {
                                                              class: {
                                                                landed_group:
                                                                  flight.status ===
                                                                    4 ||
                                                                  flight.status <
                                                                    1
                                                              },
                                                              attrs: {
                                                                column: "",
                                                                "active-class":
                                                                  "primary--text"
                                                              }
                                                            },
                                                            _vm._l(
                                                              flight.assigned_jumps,
                                                              function(
                                                                assigned_jump,
                                                                j
                                                              ) {
                                                                return _c(
                                                                  "v-chip",
                                                                  {
                                                                    key:
                                                                      assigned_jump.jumpId,
                                                                    attrs: {
                                                                      disabled: !_vm.viewingToday,
                                                                      close: ""
                                                                    },
                                                                    on: {
                                                                      "click:close": function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.remove_jump(
                                                                          flight.id,
                                                                          assigned_jump.jumpId,
                                                                          f
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              assigned_jump.code
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            assigned_jump.fullName
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              assigned_jump.customerW
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            assigned_jump.instructorName
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              assigned_jump.instructorW
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-col", [
                                                        _c(
                                                          "p",
                                                          [
                                                            _c("strong", [
                                                              _vm._v("Notes:")
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  flight.notes
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    !_vm.viewingToday &&
                                                                    !_vm.checkGate(
                                                                      "load-undo"
                                                                    ),
                                                                  icon: "",
                                                                  depressed: "",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.edit(
                                                                      flight
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      center: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-pencil"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-actions",
                                                    [
                                                      _vm._v(
                                                        "\n\n                      Total Weight: " +
                                                          _vm._s(
                                                            flight.assigned_jumps
                                                              ? _vm.sum(
                                                                  flight.assigned_jumps,
                                                                  "instructorW"
                                                                ) +
                                                                  _vm.sum(
                                                                    flight.assigned_jumps,
                                                                    "customerW"
                                                                  ) +
                                                                  flight.pilotWeight
                                                              : flight.pilotWeight
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      flight.status === 1 &&
                                                      (flight.assigned_jumps ===
                                                        null ||
                                                        flight.assigned_jumps
                                                          .length === 0)
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "red--text",
                                                              attrs: {
                                                                small: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.del(
                                                                    flight.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-delete-forever"
                                                                )
                                                              ]),
                                                              _vm._v(" Delete")
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("DayPicker", { on: { reloadData: _vm.loadData } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }